/* eslint-disable complexity */
import React, {useEffect} from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { makePriceLabelRound } from "../../../../au-c2b/utils/helpers/make-price-label";
import { BOOL_STATE, EMPLOYEMENT_TYPES, LIVING_SITUATION, RESIDENCY_STATUS } from "../../../../constants/checkout-constants";
import editIcon from "./images/edit.svg";
import { AU_DESKTOP_EVENTS } from "../../../../tracking/au.desktop-events";
import { trackDesktopCustomEventsAU } from "../../../../tracking";
import Tick from "./images/tick.svg";
import { getPreApprovedAmount } from "../../../../utils/helpers/get-pre-approved-amount";

const PreApprovalPersonalReadDetails = ({
    maxPermissibleRepaymentPerWeek,
    financeData,
    handleEditcallback = () => {},
    inHouseFinanceEligibilityFinance,
    getPreApprovalLoanDetailsConnect,
    absolutePermissibleLoanAmount
}) => {
    const { user = {}, loan = {}, loanType = {}} = financeData || {};
    const { firstName = "", middleName = "", lastName = "", dateOfBirth, address = {}, previousAddress = {}, residency, employment = [], livingSituation, employmentIndustryContinuation, relationshipStatus, dependants, userIncomeDetails} = user || {};
    const { deposit, term, balloon } = loan || {};
    const { isPurposeBusiness, isAbnRegistered, isGstRegistered, businessYears  } = loanType || {};
    const { grossIncome = null, partnerGrossIncome = null, livingExpenses = null, mortgageOrRentPayment = null, grossIncomeDuration = null, partnerGrossIncomeDuration = null, livingExpensesDuration = null, mortgageOrRentPaymentDuration = null } = userIncomeDetails || {};
    const isCommercialForm = inHouseFinanceEligibilityFinance && isPurposeBusiness === "YES";
    const handleEdit = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.PRE_APPROVAl_EDIT_MY_ACCOUNT);
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.EDIT_FLOW, {
            eventAction: "Flow_source",
            eventLabel: "My account page"
        });
        handleEditcallback(true);
    };
    const getDurationLabel = (duration, type = "year") => {
        if (duration > 1) {
            if (type === "month") {
                return "months";
            }
            return "years";
        }
        return type;
    };

    useEffect(() => {
        getPreApprovalLoanDetailsConnect({fetchListingDetails: true});
    }, [getPreApprovalLoanDetailsConnect]);

    return (
        <div>
            <p styleName={"styles.description"}>You’ve been pre-approved for finance up to <img src={Tick} /></p>
            <p styleName={"styles.preApprovedAmount"}>{getPreApprovedAmount(absolutePermissibleLoanAmount, maxPermissibleRepaymentPerWeek)}</p>
            <div styleName={"styles.chooseCarStrip"}>
                <p styleName={"styles.chooseCarStripText"}>{absolutePermissibleLoanAmount ? "Choose a car within this amount" : "Choose car within this repayment limit"}</p>
            </div>

            <div styleName={"styles.headingWrapper"}>
                <h3 styleName={"styles.heading"}>Your financing details</h3>
                <p styleName={"styles.editWrapper"} onClick={handleEdit}>
                    <img src={editIcon} alt={"editIcon"} />
                    Edit details
                </p>
            </div>
            <div styleName={"styles.boxWrapper"}>
                <div styleName={"styles.boxHeadingWrap"}>
                    <p styleName={"styles.detail"}>LOAN DETAILS</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Deposit amount</p>
                    <p styleName={"styles.subjectAmount"}>{makePriceLabelRound(deposit)}</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Loan tenure</p>
                    <p styleName={"styles.subjectAmount"}>{term} {getDurationLabel(term)}</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Balloon</p>
                    <p styleName={"styles.subjectAmount"}>{balloon}%</p>
                </div>
            </div>
            <div styleName={"styles.boxWrapper"}>
                <div styleName={"styles.boxHeadingWrap"}>
                    <p styleName={"styles.detail"}>LOAN TYPE</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Bussiness</p>
                    <p styleName={"styles.subjectAmount"}>{isPurposeBusiness}</p>
                </div>
                {!isCommercialForm && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>ABN registered</p>
                    <p styleName={"styles.subjectAmount"}>{isAbnRegistered || "NO"}</p>
                </div>}
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>GST registered</p>
                    <p styleName={"styles.subjectAmount"}>{isGstRegistered || "NO"}</p>
                </div>
                {!isCommercialForm && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Bussiness Years</p>
                    <p styleName={"styles.subjectAmount"}>{businessYears || 0} {getDurationLabel(businessYears || 0)}</p>
                </div>}
            </div>
            <div styleName={"styles.boxWrapper"}>
                <div styleName={"styles.boxHeadingWrap"}>
                    <p styleName={"styles.detail"}>PERSONAL DETAILS</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Name</p>
                    <p styleName={"styles.subjectAmount"}>{`${firstName} ${middleName} ${lastName}`}</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>D.O.B.</p>
                    <p styleName={"styles.subjectAmount"}>{dateOfBirth}</p>
                </div>
                {!isCommercialForm && !!relationshipStatus && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Relationship Status</p>
                    <p styleName={"styles.subjectAmount"}>{relationshipStatus}</p>
                </div>}
                {!isCommercialForm && typeof dependants === "number" && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>No of dependents</p>
                    <p styleName={"styles.subjectAmount"}>{dependants}</p>
                </div>}
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Residency status</p>
                    <p styleName={"styles.subjectAmount"}>{RESIDENCY_STATUS.filter((data) => data.value === residency)[0] && RESIDENCY_STATUS.filter((data) => data.value === residency)[0].label}</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Address</p>
                    <p styleName={"styles.subjectAmount"}>{address.full}</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Address Tenure</p>
                    <p styleName={"styles.subjectAmount"}>{address.durationYears} {getDurationLabel(address.durationYears)} {address.durationMonths} {getDurationLabel(address.durationMonths, "month")}</p>
                </div>
                {previousAddress.full &&
                    <React.Fragment>
                        <div styleName={"styles.flexWrapper"}>
                            <p styleName={"styles.subject"}>Previous Address</p>
                            <p styleName={"styles.subjectAmount"}>{previousAddress.full}</p>
                        </div>
                        <div styleName={"styles.flexWrapper"}>
                            <p styleName={"styles.subject"}>Previous Address Tenure</p>
                            <p styleName={"styles.subjectAmount"}>{previousAddress.durationYears} {getDurationLabel(previousAddress.durationYears)} {previousAddress.durationMonths} {getDurationLabel(previousAddress.durationMonths, "month")}</p>
                        </div>
                    </React.Fragment>
                }
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Living Situation</p>
                    <p styleName={"styles.subjectAmount"}>{(LIVING_SITUATION.filter((data) => data.value === livingSituation)[0] || {}).label}</p>
                </div>
            </div>
            <div styleName={"styles.boxWrapper"}>
                <div styleName={"styles.boxHeadingWrap"}>
                    <p styleName={"styles.detail"}>EMPLOYMENT DETAILS</p>
                </div>
                <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Type</p>
                    <p styleName={"styles.subjectAmount"}>{employment[0] && EMPLOYEMENT_TYPES.filter((data) => data.value === employment[0].type)[0].label}</p>
                </div>
                {typeof (employment[0] && employment[0].durationYears) === "number" && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Current Employment tenure </p>
                    <p styleName={"styles.subjectAmount"}>{employment[0] && employment[0].durationYears} {getDurationLabel(employment[0].durationYears)} {employment[0].durationMonths} {getDurationLabel(employment[0].durationMonths, "month")}</p>
                </div>}
                {typeof (employment[1] && employment[1].durationYears) === "number" && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Previous Employment Tenure </p>
                    <p styleName={"styles.subjectAmount"}>{employment[1] && employment[1].durationYears} {getDurationLabel(employment[1].durationYears)} {employment[1].durationMonths} {getDurationLabel(employment[1].durationMonths, "month")}</p>
                </div>}
                {typeof employmentIndustryContinuation === "boolean" && typeof (employment[1] && employment[1].durationYears) === "number" && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Same Industry as before</p>
                    <p styleName={"styles.subjectAmount"}>{employmentIndustryContinuation ? BOOL_STATE.YES : BOOL_STATE.NO}</p>
                </div>}
                {!isCommercialForm && <React.Fragment>
                    {typeof grossIncome === "number" && <div styleName={"styles.flexWrapper"}>
                        <p styleName={"styles.subject"}>{(relationshipStatus === "single" || relationshipStatus === "other") ? "Gross income" : "Your Gross Income"}</p>
                        <p styleName={"styles.subjectAmount"}>{makePriceLabelRound(grossIncome)}</p>
                    </div>}
                    {grossIncomeDuration && <div styleName={"styles.flexWrapper"}>
                        <p styleName={"styles.subject"}>{(relationshipStatus === "single" || relationshipStatus === "other") ? "Gross Income Duration" : "Your Gross Income Duration"}</p>
                        <p styleName={"styles.subjectAmount"}>{grossIncomeDuration}</p>
                    </div>}
                    {typeof partnerGrossIncome === "number" && (relationshipStatus === "married" || relationshipStatus === "defacto") && <div styleName={"styles.flexWrapper"}>
                        <p styleName={"styles.subject"}>Your Partner's Gross Income</p>
                        <p styleName={"styles.subjectAmount"}>{makePriceLabelRound(partnerGrossIncome)}</p>
                    </div>}
                    {partnerGrossIncomeDuration && (relationshipStatus === "married" || relationshipStatus === "defacto") && <div styleName={"styles.flexWrapper"}>
                        <p styleName={"styles.subject"}>Your Partner's Gross Income Duration</p>
                        <p styleName={"styles.subjectAmount"}>{partnerGrossIncomeDuration}</p>
                    </div>}
                    {typeof livingExpenses === "number" && <div styleName={"styles.flexWrapper"}>
                        <p styleName={"styles.subject"}>{(relationshipStatus === "single" || relationshipStatus === "other") ?  "Living Expenses" : "Your Share Of Living Expenses"}</p>
                        <p styleName={"styles.subjectAmount"}>{makePriceLabelRound(livingExpenses)}</p>
                    </div>}
                    {livingExpensesDuration && <div styleName={"styles.flexWrapper"}>
                        <p styleName={"styles.subject"}>{(relationshipStatus === "single" || relationshipStatus === "other") ?  "Living Expenses Duration" : "Your Share Of Living Expenses Duration"}</p>
                        <p styleName={"styles.subjectAmount"}>{livingExpensesDuration}</p>
                    </div>}
                    {typeof mortgageOrRentPayment === "number"  && <div styleName={"styles.flexWrapper"}>
                        <p styleName={"styles.subject"}> {(relationshipStatus === "married" || relationshipStatus === "defacto") ? "Your Share Of Residential Expenses" : "Residential Expenses"}</p>
                        <p styleName={"styles.subjectAmount"}>{makePriceLabelRound(mortgageOrRentPayment)}</p>
                    </div>}
                    {/* {mortgageOrRentPayment && <div styleName={"styles.flexWrapper"}>
                    <p styleName={"styles.subject"}>Residential Expenses</p>
                    <p styleName={"styles.subjectAmount"}>{makePriceLabelRound(mortgageOrRentPayment)}</p>
                </div>} */}
                    {mortgageOrRentPaymentDuration && <div styleName={"styles.flexWrapper"}>
                        <p styleName={"styles.subject"}> {(relationshipStatus === "married" || relationshipStatus === "defacto") ? "Your Share Of Residential Expenses Duration" : "Residential Expenses Duration"}</p>
                        <p styleName={"styles.subjectAmount"}>{mortgageOrRentPaymentDuration}</p>
                    </div>}
                </React.Fragment>}
            </div>
        </div>
    );
};

PreApprovalPersonalReadDetails.propTypes = {
    financeData: PropTypes.object,
    inHouseFinanceEligibilityFinance: PropTypes.bool,
    handleEditcallback: PropTypes.func,
    maxLoanAmount: PropTypes.number,
    bestInterestRate: PropTypes.number,
    comparisonRate: PropTypes.number,
    updateFilterOptionDataConnect: PropTypes.func,
    maxPermissibleRepaymentPerWeek: PropTypes.number,
    getPreApprovalLoanDetailsConnect: PropTypes.func,
    listingCount: PropTypes.number,
    fetchListingCountConnect: PropTypes.func,
    absolutePermissibleLoanAmount: PropTypes.number
};

export default PreApprovalPersonalReadDetails;
